import { getEls, addEventListeners } from "./helpers.js";
import EventHandlers from "./EventHandlers.js";

var EventListeners = new Object();

EventListeners.init = function () {
  var { elParentMenuItems, elSubmenu, elMobileMenuToggleBtn, elMobileSubmenuToggleBtns } = getEls();

  elParentMenuItems.forEach((el) => {
    el.addEventListener("click", (event) => EventHandlers.MenuItem.parentClick(event, el));
    el.addEventListener("mouseenter", (event) => EventHandlers.MenuItem.mouseenter(event, el));
    el.addEventListener("mouseleave", (event) => EventHandlers.MenuItem.mouseleave(event, el));
  });

  addEventListeners(elSubmenu, "mouseleave", EventHandlers.submenuMouseleave);

  window.addEventListener("scroll", EventHandlers.windowScroll);

  addEventListeners(elMobileMenuToggleBtn, "click", (event) =>
    EventHandlers.Mobile.togglerClick(event, elMobileMenuToggleBtn),
  );

  addEventListeners(elMobileSubmenuToggleBtns, "click", EventHandlers.Mobile.toggleSubmenu);
};

export default EventListeners;
